import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon, SelectorIcon } from '@heroicons/react/solid';
import { Fragment } from 'react';
import type { BusinessAccount, FacebookBusinessAccounts } from './types';

export const BusinessAccountsSelector = ({
  businessAccounts,
  selectedBusinessAccount,
  setSelectedBusinessAccount,
}: {
  businessAccounts: FacebookBusinessAccounts['data'];
  selectedBusinessAccount: BusinessAccount;
  setSelectedBusinessAccount: React.Dispatch<
    React.SetStateAction<BusinessAccount>
  >;
}) => {
  return (
    <div className="w-40 mt-4">
      <Listbox
        value={selectedBusinessAccount}
        onChange={setSelectedBusinessAccount}
      >
        <div className="relative mt-1">
          <Listbox.Button className="relative w-full py-2 pl-3 pr-10 text-left bg-white rounded-lg shadow-md cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm">
            <span className="block truncate">
              {selectedBusinessAccount?.name}
            </span>
            <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
              <SelectorIcon
                className="w-5 h-5 text-gray-400"
                aria-hidden="true"
              />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
              {businessAccounts.map((account, accountIdx) => (
                <Listbox.Option
                  key={accountIdx}
                  className={({ active }) =>
                    `${
                      active
                        ? 'text-black bg-segments-accent-color-1 bg-opacity-5'
                        : 'text-gray-900'
                    }
                          cursor-default select-none relative py-2 pl-10 pr-4`
                  }
                  value={account}
                >
                  {({ selected, active }) => (
                    <>
                      <span
                        className={`${
                          selected ? 'font-medium' : 'font-normal'
                        } block truncate`}
                      >
                        {account.name}
                      </span>
                      {selected ? (
                        <span
                          className={`${
                            active ? 'text-amber-600' : 'text-amber-600'
                          }
                                absolute inset-y-0 left-0 flex items-center pl-3`}
                        >
                          <CheckIcon
                            className="w-5 h-5 text-segments-accent-color-orange"
                            aria-hidden="true"
                          />
                        </span>
                      ) : null}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
};
